module.exports = __webpack_public_path__ + "img/header-2.5c458182.png";